/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {FaRoad as ScenarioAnalysisAppIcon} from 'react-icons/fa';


/* Application */
const APP_TITLE = 'Scenario Analysis Models'
const APP_ICON = <ScenarioAnalysisAppIcon style={{width: 30, height: 50, marginRight: 10}} />


/* Page Titles */
const LANDING_TITLE = 'Automated Driving Scenario Analysis Models'
const VIEW_MODEL_TITLE = 'View Model'
const VIEW_VARIABLES_TITLE = 'View Variables'


/* Page Routes */
const BASE_ROUTE = '/scenario-analysis'
const VIEW_MODEL_ROUTE = BASE_ROUTE + '/model'
const VIEW_VARIABLES_ROUTE = BASE_ROUTE + '/variables'


/* Endpoints */
const BASE_SCENARIO_ANALYSIS_ENDPOINT = '/HttpTriggerScenarioAnalysis'

enum RequestKeys {
  PAGE = 'p',
  REQUEST = 'req',
}

enum Pages {
  LANDING = 'landing',
  VIEW_MODEL = 'viewModel',
  VIEW_VARIABLES = 'viewVariables',
}

enum Requests {
  /* Landing */
  MODELS_TABLE = 'modelsTable',

  /* View Model */
  MODELS_LIST = 'modelsList',
  VERSIONS_LIST = 'versionsList',
  VARIATIONS_LIST = 'variationsList',
  MODEL_DESCRIPTION = 'modelDescription',
  MODEL_PARAMETER_LIST = 'modelParameterList',
  MODEL_EXECUTION = 'modelExecution',
  MODEL_TRACKED_ITEM_ID = 'modelTrackedItemId',

  /* View Variables */
  VARIABLES_TABLE = 'variablesTable',
  VARIABLE_MODEL_USAGE = 'variableModelUsage',
}

const formRequestUrl = (page: Pages, request: Requests) => {
  return `${BASE_SCENARIO_ANALYSIS_ENDPOINT}?${RequestKeys.PAGE}=${page}&${RequestKeys.REQUEST}=${request}`
}


/* Constants */
const SCENARIO_ANALYSIS_CONSTANTS = {
  app: {
    title: APP_TITLE,
    icon: APP_ICON,
  },
  landing: {
    title: LANDING_TITLE,
    route: BASE_ROUTE,
    endpoints: {
      modelsTable: formRequestUrl(Pages.LANDING, Requests.MODELS_TABLE),
    },
  },
  viewModel: {
    title: VIEW_MODEL_TITLE,
    route: VIEW_MODEL_ROUTE,
    endpoints: {
      modelsList: formRequestUrl(Pages.VIEW_MODEL, Requests.MODELS_LIST),
      versionsList: formRequestUrl(Pages.VIEW_MODEL, Requests.VERSIONS_LIST),
      variationsList: formRequestUrl(Pages.VIEW_MODEL, Requests.VARIATIONS_LIST),
      modelDescription: formRequestUrl(Pages.VIEW_MODEL, Requests.MODEL_DESCRIPTION),
      modelParameterList: formRequestUrl(Pages.VIEW_MODEL, Requests.MODEL_PARAMETER_LIST),
      modelExecution: formRequestUrl(Pages.VIEW_MODEL, Requests.MODEL_EXECUTION),
      modelTrackedItemId: formRequestUrl(Pages.VIEW_MODEL, Requests.MODEL_TRACKED_ITEM_ID),
    },
    constants: {
      states: {
        tabId: "t",
        initTabIdx: 0,
      },
    },
  },
  viewVariables: {
    title: VIEW_VARIABLES_TITLE,
    route: VIEW_VARIABLES_ROUTE,
    endpoints: {
      variablesTable: formRequestUrl(Pages.VIEW_VARIABLES, Requests.VARIABLES_TABLE),
      variableModelUsage: formRequestUrl(Pages.VIEW_VARIABLES, Requests.VARIABLE_MODEL_USAGE),
    },
  },
} 


export {
  SCENARIO_ANALYSIS_CONSTANTS,
}
